import {withTranslation, WithTranslation} from '@wix/yoshi-flow-editor'
import {internalNavigate} from '../../../actions/navigation'
import {DetailedEvent, MemberPageContext} from '../../../types/state'
import {connect} from '../../connect'
import {GoToOrderButton as GoToOrderButtonPresentation} from './go-to-order-button'

export interface GoToOrderButtonProps extends GoToOrderButtonOwnProps, GoToOrderButtonRuntimeProps, WithTranslation {}

interface GoToOrderButtonOwnProps {
  event: DetailedEvent
}

interface GoToOrderButtonRuntimeProps {
  internalNavigate: typeof internalNavigate
}

const mapRuntime = ({actions}: MemberPageContext) => ({
  internalNavigate: actions.internalNavigate,
})

export const GoToOrderButton = connect<GoToOrderButtonOwnProps, GoToOrderButtonRuntimeProps>(mapRuntime)(
  withTranslation()(GoToOrderButtonPresentation),
)
